import HistoryDisplay from '../../../history/HistoryDisplay';

export default function SearchStudentHistoryTab({ studentId }) {
    return (
        <>
            <HistoryDisplay studentId={studentId} employeeMode />
        </>
    );
}

